module.exports = __webpack_public_path__ + "assets/2e698c9c6392ab66f5431a00342f34f9.png";